<template>
  <div>
    <div class="py-2">
      <section-pdf-viewer :sectionDoc="section"
                          :disableExtend="true"
                          :extended="extended"
                          :maximise="!dialog"
                          :fullscreen="dialog"
                          :dialog="dialog"
                          :mode="document.mode"
                          @closeDialog="closeDialog">
      </section-pdf-viewer>
    </div>
  </div>
</template>
<script lang="ts">
  import Section from '@/framework/base/classes/Section';
  import Document, { DocumentModes } from '@/generated/classes/Document';
  import SectionPdfViewer from '@/framework/document/components/SectionPdfViewer.vue';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  import Route from '@/generated/classes/Route';
  import { defineComponent, type PropType } from "vue";
  import Button from "@/framework/base/classes/Button.ts";
  import { PaieStatuts } from "@/generated/classes/Paie.ts";
  import { ContratStatuts } from "@/generated/classes/Contrat.ts";
  import { AppButtons, FwkButtons, RessourceAppButton, RessourceFwkButton } from "@/ressources/globalRessources.ts";
  import Files, { DownloadData } from "@/generated/classes/Files.ts";
  import { getBlob } from "@/framework/files/helpers/FileTypes.ts";
  import { storePaymentMeans } from '@/generated/stores';
  import PaymentMeans from '@/generated/classes/PaymentMeans';

  export default defineComponent({
    components: { SectionPdfViewer },
    props: {
      hideTitle: {
        type: Boolean
      },
      document: {
        type: Object as PropType<Document>,
        required: true
      },
      dialog: {
        type: Boolean
      },
      extended: {
        type: Boolean
      },
      readOnly: {
        type: Boolean
      },
      route: {
        type: Object as PropType<Route>
      }
    },
    data() {
      return {
        signing: false,
      };
    },
    computed: {
      section(): Section {
        const section = new Section();
        section.objType = ObjTypes.DOCUMENT;
        section.objId = this.document.id;
        section.buttons = this.buttons;
        return section;
      },
      mandatToSign(): boolean {
        let res = false;
        if (this.document.objType == ObjTypes.MANDAT_B2C) {
          const pm = storePaymentMeans.getPaymentMeans(this.document.objId);
          if (pm && pm.b2cSignedAt == null) {
            res = true;
          }
        } else if (this.document.objType == ObjTypes.MANDAT_B2B) {
          const pm = storePaymentMeans.getPaymentMeans(this.document.objId);
          if (pm && pm.b2bSignedAt == null) {
            res = true;
          }
        }
        return res;
      },
      downloadOrSign(): string {
        let res = RessourceFwkButton(FwkButtons.DOWNLOAD_DOCUMENT).label;
        if (this.mandatToSign) {
          res = 'Signer le mandat';
        }
        return res;
      },
      buttons(): Button[] {
        const buttons: Button[] = [];
        {
          const button = new Button();
          button.show = true;
          button.label = this.downloadOrSign;
          button.callback = this.DownloadDocument;
          button.disabled = this.signing;
          buttons.push(button);
        }
        {
          const button = new Button();
          button.show = true;
          button.label = RessourceFwkButton(FwkButtons.FERMER).label;
          button.callback = this.FermerDialog;
          button.disabled = false;
          buttons.push(button);
        }
        return buttons;
      },
    },
    methods: {
      FermerDialog(): Promise<void> {
        return new Promise((resolve) => {
          this.closeDialog();
          resolve();
        });
      },
      DownloadDocument(): Promise<void> {
        return new Promise((resolve) => {
          if (this.mandatToSign) {
            this.signing = true;
            PaymentMeans.signMandat(this.document).then((res) => {
              const url = res.trim();
              if (url != '') {
                window.open(encodeURI(url), '_blank');
              }
              this.signing = false;
              resolve();
            }).catch(() => {
              this.signing = false;
            });            
          } else {
            let fileName = this.document.fileName;
            const data = new DownloadData();
            data.service = 'DOWNLOAD';
            data.type.extension = this.document.fileExtension;
            data.data = JSON.stringify(this.document);
            Files.download(data)
              .then((buffer) => {
                const blob = getBlob(buffer, data.type.extension);
                const file = window.URL.createObjectURL(blob);
                const docUrl = document.createElement('a');
                if (!fileName.endsWith(data.type.extension)) {
                  fileName = `${fileName}.${data.type.extension}`
                }
                docUrl.setAttribute('href', file);
                docUrl.setAttribute('download', fileName);
                document.body.appendChild(docUrl);
                docUrl.click();
              });
            resolve();
          }
        });
      },
      closeDialog(): void {
        this.$emit('closeDialog');
      }
    }
  })

</script>
